var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showOSD
          ? _c("div", { staticClass: "input-source__osd" }, [
              _c("div", { staticClass: "osd__header" }, [
                _c(
                  "div",
                  {
                    staticClass: "osd-back",
                    class: { "osd-back--active": _vm.isBackActive }
                  },
                  [
                    _c(
                      "Icon",
                      { attrs: { color: "#f1f1f1" } },
                      [_c("ArrowLeft")],
                      1
                    ),
                    _vm._v("\n          " + _vm._s(_vm.getBack) + "\n        ")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tv-osd__header-title" }, [
                  _vm._v(_vm._s(_vm.headline))
                ])
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3713932d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3713932d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OSDHeader.vue
// module id = null
// module chunks = 